class ActiveCommentsStore {
    constructor() {
        this.current = '';
    }

    setNew(current) {
        if (this.current) {
            this.current.handleHideClick();
        }

        this.current = current;
    }
}


export const activeCommentsStore = new ActiveCommentsStore();
